var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import Radio from 'antd/lib/radio';
import Icon from './common/Icon';
import AutoComplete from './common/AutoComplete';
import SelectInput from './common/SelectInput';
import Color from './common/Color';
import { getOptionArray, getParentNode } from '../utils';
var Panel = Collapse.Panel;
var Option = Select.Option;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var EditorFont = /** @class */ (function (_super) {
    __extends(EditorFont, _super);
    function EditorFont(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (key, v, isDrag) {
            var _a;
            var value = __assign(__assign({}, _this.props.value), (_a = {}, _a[key] = v, _a));
            _this.props.onChange('font', value, isDrag);
        };
        _this.getFontFamily = function () { return (_this.font.concat(_this.props.font).sort().filter(function (item, pos, ary) { return (!pos || item !== ary[pos - 1]); }).map(function (key) { return (React.createElement(Option, { value: key, key: key, style: { fontFamily: key + ", sans-serif" } }, key)); })); };
        _this.getFontAlign = function () {
            var align = _this.props.value.align;
            align = align === 'start' ? 'left' : align;
            align = align === 'end' ? 'right' : align;
            return (React.createElement(RadioGroup, { value: align, size: "small", onChange: function (e) {
                    var target = e.target;
                    _this.onChange('align', target.value);
                } }, ['left', 'center', 'right', 'justify'].map(function (key) { return (React.createElement(RadioButton, { value: key, className: _this.props.className + "-align", key: key },
                React.createElement("div", { className: key }))); })));
        };
        _this.getFontDecoration = function () { return (React.createElement(RadioGroup, { value: _this.props.value.decoration &&
                _this.props.value.decoration.split(' ')[0], size: "small", onChange: function (e) {
                var target = e.target;
                _this.onChange('decoration', target.value);
            } }, ['none', 'underline', 'line-through', 'overline'].map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
            React.createElement("div", { className: "decoration", style: { textDecoration: key } }, "Aa"))); }))); };
        _this.font = ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Georgia', 'Impact',
            'Lucida Console', 'MS Serif', 'Palatino Linotype', 'Papyrus', 'Tahoma', 'Times New Roman',
            'Helvetica Neue', 'Segoe UI', 'Hiragino Sans GB', 'PingFang SC', 'Microsoft YaHei',
            'SimSun', 'SimHei', 'Trebuchet MS', 'Verdana'];
        _this.weight = ['bold', 'lighter', 'normal', '100', '200', '300', '400',
            '500', '600', '700', '800', '900'];
        _this.state = {
            value: props.value,
        };
        return _this;
    }
    EditorFont.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.value !== props.value) {
            nextState.value = props.value;
        }
        return nextState;
    };
    EditorFont.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, locale = _a.locale, props = __rest(_a, ["value", "locale"]);
        ['value', 'font'].map(function (key) { return delete props[key]; });
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { prompt: locale.font },
                        React.createElement("span", { className: "icon" }, "A"))),
                React.createElement(Col, { span: 21 },
                    React.createElement(SelectInput, { placeholder: locale.placeholder, style: { width: '100%' }, value: value.family, size: "small", onChange: function (e) {
                            _this.onChange('family', e);
                        } }, this.getFontFamily()))),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "font-size", prompt: locale.size })),
                React.createElement(Col, { span: 9 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, value: value.size, onChange: function (e) {
                            _this.onChange('size', e);
                        } })),
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "bold", prompt: locale.bold })),
                React.createElement(Col, { span: 9 },
                    React.createElement(Select, { style: { width: '100%' }, value: value.weight, size: "small", getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, onChange: function (e) {
                            _this.onChange('weight', e);
                        }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOptionArray(this.weight)))),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "line-height", prompt: locale.lineHeight })),
                React.createElement(Col, { span: 9 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, value: value.lineHeight, onChange: function (e) {
                            _this.onChange('lineHeight', e);
                        } })),
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "letterSpacing", prompt: locale.letterSpacing })),
                React.createElement(Col, { span: 9 },
                    React.createElement(AutoComplete, { style: { width: '100%' }, value: value.letterSpacing, onChange: function (e) {
                            _this.onChange('letterSpacing', e);
                        } }))),
            React.createElement(Color, { color: value.color, title: React.createElement(Icon, { type: "font-colors", prompt: locale.color }), onChange: function (e, isDrag) {
                    _this.onChange('color', e, isDrag);
                } }),
            React.createElement(Row, null,
                React.createElement(Col, { span: 21, offset: 3 }, this.getFontDecoration())),
            React.createElement(Row, null,
                React.createElement(Col, { span: 21, offset: 3 }, this.getFontAlign()))));
    };
    EditorFont.propTypes = {
        className: PropTypes.string,
        header: PropTypes.string,
        font: PropTypes.array,
        value: PropTypes.object,
        onChange: PropTypes.func,
        locale: PropTypes.object,
    };
    EditorFont.defaultProps = {
        className: 'editor-font',
        font: [],
        value: {
            family: 'Helvetica Neue',
            size: '1rem',
            weight: 'normal',
            lineHeight: 1.2,
            color: '#000',
            letterSpacing: '0',
            align: 'left',
            decoration: 'none',
        },
        onChange: function () {
        },
    };
    return EditorFont;
}(Component));
EditorFont.componentName = 'EditorFont';
export default EditorFont;
